import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'antd';
import { BaseBreadcrumbWithRender } from '@app/components/common/BaseBreadcrumb/BaseBreadcrumb';
import { useHeader } from '@app/components/header/layouts/HeaderContext';
import FarmLocations from '@app/components/apps/FarmLocations/FarmLocationForm';

export const ViewFarm: React.FC = () => {
  const location = useLocation();
  const { id } = location.state || {};
  const { t } = useTranslation();
  const [currentBreadcrumName, setCurrentBreadcrumName] = useState<string>('View Establishment / Farm');
  const { setBreadcrumb, clearHeaderButtons } = useHeader();

  const routes = [
    { path: '/all-farms', breadcrumbName: 'My Establishments / Farms' },
    { path: '/view-farm', breadcrumbName: currentBreadcrumName },
  ];

  useEffect(() => {
    setBreadcrumb(<BaseBreadcrumbWithRender routes={routes} separator=">" />);

    return () => {
      setBreadcrumb(undefined);
      clearHeaderButtons();
    };
  }, [currentBreadcrumName]);

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <FarmLocations
          type={'view'}
          editable={false}
          id={id}
          pageTitle={`View Establishment / Farm`}
          setCurrentBreadcrumName={setCurrentBreadcrumName}
        />
      </Col>
    </Row>
  );
};

export default ViewFarm;
